module.exports = __webpack_public_path__ + "static/media/fotter_shap.572a3f58.png";